module.exports = __webpack_public_path__ + "static/media/GS.3d7f87ad.svg";